import { render, staticRenderFns } from "./QuestionsGrid.vue?vue&type=template&id=55616680&"
import script from "./QuestionsGrid.vue?vue&type=script&lang=js&"
export * from "./QuestionsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports